class TaskListsController {
    init() {

    }

    index() {

    }

    edit() {
        // Hide task elements
        document.querySelectorAll('.task-complete, .task-client, .task-date').forEach(element => {
            element.style.display = 'none';
        });
        
        // Task list sorting migrated to Stimulus sortable controller
        // See app/javascript/controllers/sortable_controller.js
        
        // Handle inline form changes
        document.addEventListener('change', (event) => {
            const target = event.target;
            if (target.matches('.task-name, .task-user')) {
                const newTaskParent = target.closest('#new_task');
                if (!newTaskParent) {
                    const form = target.closest('form');
                    if (form) {
                        form.submit();
                    }
                }
            }
        });
        
        document.addEventListener('keyup', (event) => {
            const target = event.target;
            if (target.matches('.task-name')) {
                const newTaskParent = target.closest('#new_task');
                if (!newTaskParent) {
                    const form = target.closest('form');
                    if (form) {
                        form.submit();
                    }
                }
            }
        });
        
        document.addEventListener('click', (event) => {
            const target = event.target;
            if (target.matches('.task-priority')) {
                const newTaskParent = target.closest('#new_task');
                if (!newTaskParent) {
                    const form = target.closest('form');
                    if (form) {
                        form.submit();
                    }
                }
            }
        });
    }
    
    // updateTaskOrder method removed - now handled by Stimulus sortable controller
}

window.BC = window.BC || {};
window.BC.task_lists = new TaskListsController();